import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%'
    },
    summary: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold',
      backgroundColor: 'rgba(0, 0, 0, .03)',
      border: '1px solid rgba(0, 0, 0, .125)',
      marginBottom: -1,
      minHeight: 45,
      flexDirection: 'row-reverse',
      padding: 0
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold'
    },
    expandIcon: {
      transform: 'rotate(270deg)',
      '&$expanded': {
        transform: 'rotate(360deg)'
      }
    },
    expanded: {},
    content: {
      alignItems: 'center'
    }
  })
)
